import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { Loading } from "../../layout/secure/common";
import SecureShell from "../../layout/secure/shell";
import {
  buildLoginRedirectUrl,
  surveyLoginUrl,
} from "../../utils/auth-redirect";
import Home from "../../views/secure/home";
import Invitations from "../../views/secure/invitations";
import Results from "../../views/secure/results";
import ResponseReport from "../../views/secure/response-report";
import AggregateReport from "../../views/secure/aggregate-report";
import Settings from "../../views/secure/settings";
import SurveyPage from "../../views/secure/survey-page";
import Surveys from "../../views/secure/surveys";
import Usage from "../../views/secure/usage";
import Users from "../../views/secure/users";
import WordPressConnect from "../../views/secure/wordpress-connect";
import WordPressManualConnect from "../../views/secure/wordpress-manual-connect";

const FERASURVEY_LOGO_LIGHT = `${process.env.PUBLIC_URL || ""}/branding/fera/logos/survey/fera-survey-light.svg`;

const SurveyEditor = lazy(() => import("../../views/secure/editor"));
const SurveyPreview = lazy(() => import("../../views/secure/editor/preview"));

const editorRoute = component => (
  <Suspense fallback={<Loading label="Loading Survey editor" />}>
    {component}
  </Suspense>
);

function SignInRequired() {
  const authRoot = surveyLoginUrl();
  const loginUrl = buildLoginRedirectUrl(authRoot, window.location.href) || authRoot;
  return (
    <main className="fera-secure-shell fera-centered">
      <section className="fera-auth-card" aria-labelledby="sign-in-title">
        <img className="fera-auth-logo" src={FERASURVEY_LOGO_LIGHT} alt="FeraSurvey" />
        <p className="fera-eyebrow">FeraSurvey</p>
        <h1 id="sign-in-title">Sign in to FeraSurvey</h1>
        <p className="text-muted">Use your FeraAuth account to build surveys, manage distribution, and view permitted results.</p>
        <a className="btn btn-primary w-100" href={loginUrl}>Continue to Feradel Auth</a>
      </section>
    </main>
  );
}

function SecureRoutes() {
  if (!localStorage.token || !localStorage.instance) return <SignInRequired />;
  return (
    <SecureShell>
      <Routes>
        <Route index element={<Home />} />
        <Route path="surveys" element={<Surveys />} />
        <Route path="surveys/new" element={<SurveyPage mode="new" />} />
        <Route path="surveys/:surveyId" element={<SurveyPage mode="detail" />} />
        <Route path="surveys/:surveyId/edit" element={editorRoute(<SurveyEditor />)} />
        <Route path="surveys/:surveyId/preview" element={editorRoute(<SurveyPreview />)} />
        <Route path="surveys/:surveyId/results" element={<Results />} />
        <Route path="surveys/:surveyId/results/:responseId" element={<ResponseReport />} />
        <Route path="surveys/:surveyId/report" element={<AggregateReport />} />
        <Route path="results" element={<Results />} />
        <Route path="invitations" element={<Invitations />} />
        <Route path="users" element={<Users />} />
        <Route path="usage" element={<Usage />} />
        <Route path="settings" element={<Settings />} />
        <Route
          path="settings/integrations/wordpress/connect"
          element={<WordPressConnect />}
        />
        <Route
          path="settings/integrations/wordpress/manual"
          element={<WordPressManualConnect />}
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </SecureShell>
  );
}

export default SecureRoutes;
